module.exports = __webpack_public_path__ + "static/media/icon-stats-up.d71c463a.svg";